<template>
  <div class="dropdown dropdown-message">
    <a
      @click="loadConversation()"
      class="dropdown-link"
      data-toggle="dropdown"
      role="button"
    >
      <feather type="message-square" class="wd-26 ht-26"></feather>
      <span class="d-none d-sm-inline mg-l-10">
        Зурвас
        <sup
          >({{ this.$store.state.signalr.team.notSeenConversationCount }})</sup
        >
      </span>
    </a>
    <div class="dropdown-menu dropdown-menu-right">
      <div class="dropdown-header">Шинэ зурвасууд</div>
      <template v-for="conv in conversations">
        <router-link
          :to="`/lms/courseView/${conv.courseId}/0/0/0`"
          :class="`dropdown-item ${conv.count > 0 ? 'bg-light' : ''}`"
          :key="conv.id"
        >
          <div class="media">
            <div class="avatar avatar-sm avatar-online">
              <img
                :src="`${conv.lastMessage.user.avator}?w=32&h=32&mode=crop`"
                class="rounded-circle"
                :alt="conv.lastMessage.user.fullName"
              />
            </div>
            <div class="media-body mg-l-15">
              <strong
                >{{ conv.lastMessage.user.fullName }} - {{ conv.team }}</strong
              >
              <p>{{ conv.lastMessage.msg }}</p>
              <span>{{ conv.lastMessage.date }}</span>
            </div>
          </div>
        </router-link>
      </template>
      <!-- <div class="dropdown-footer">
        <a href>Бүх Зурвас</a>
      </div>-->
    </div>
    <!-- dropdown-menu -->
  </div>
</template>

<script>
import { request } from "@/api/all";
import { mapActions } from "vuex";

export default {
  props: {
    prop: {
      flag: Number,
      default: () => 115
    }
  },
  data() {
    return {
      conversations: [],
      notSeenCount: 0
    };
  },
  mounted() {
    this.loadNotSeenCount();
  },
  methods: {
    ...mapActions(["handleTeamNotSeenCount"]),
    loadNotSeenCount() {
      request({
        api: { method: "get", url: "team/NotSeenConversationCount" },
        params: { flag: 115 },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.handleTeamNotSeenCount(res.data.count);
        }
      });
    },
    loadConversation() {
      request({
        api: { method: "get", url: "team/GetTeamConversations" },
        params: { id: 0, flag: 115, skip: 0, size: 10 },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.conversations = res.data.conversations;
          this.loadNotSeenCount();
        }
      });
    }
  }
};
</script>
